import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Get ID from URL params
import axios from "axios";
import { baseurl } from "../../../component/Baseurl"; // Ensure baseurl is correct
import Swal from "sweetalert2";
import Sidebar from "./Sidebar";
import BreadCrumb from "./BreadCrumb";
import { useNavigate } from "react-router-dom"; 



function EditDistributor() {
  const { id } = useParams(); // Get ID from URL parameter
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    business_name: "",  
    status: "",
    flight_markup: "",
    hotel_markup: "",
    bus_markup: "",
    recharge_markup: "",
    cost_per_pin: "",
  });

  // Fetch distributor details by ID
  useEffect(() => {
    axios
      .get(`${baseurl}/getDistributorById/${id}`)
      .then((response) => {

        console.log("response",response);

        if (response.data.distributor) {
          setFormData(response.data.distributor); // Pre-fill form with fetched data
        }
      })
      .catch((error) => {
        console.error("Error fetching distributor:", error);
        Swal.fire("Error", "Failed to fetch distributor data", "error");
      });
  }, [id]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };



  const navigate = useNavigate();



const handleSubmit = async (e) => {
  e.preventDefault();


  console.log("formData",formData);
  try {
    const response = await axios.put(`${baseurl}updateDistributorById/${id}`, formData);
    Swal.fire("Success", response.data.message, "success").then(() => {
      navigate(-1); // Navigate back after success
    });
  } catch (error) {
    console.error("Error updating distributor:", error);
    Swal.fire("Error", "Failed to update distributor", "error");
  }
};

  return (
    <>






<div className="App" style={{ display: "flex" }}>
        <Sidebar/>
        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
           <BreadCrumb/>
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Distributors</h2>
                   
                </div>

              
                <div>
        <form onSubmit={handleSubmit}>
          <div className="row g-1 text-start">
            <div className="col-md-12">
              <label className="text-dark mb-1 labelset2 font3">Distributor Name</label>
              <input
                type="text"
                name="name"
                className="input1"
                placeholder="Enter name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="text-dark mb-1 labelset2 font3">Phone</label>
              <input
                type="text"
                name="phone"
                className="input1"
                placeholder="Enter phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="text-dark mb-1 labelset2 font3">Email</label>
              <input
                type="email"
                name="email"
                className="input1"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-12">
              <label className="text-dark mb-1 labelset2 font3">Address</label>
              <input
                type="text"
                name="address"
                className="input1"
                placeholder="Enter address"
                value={formData.address || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">City</label>
              <input
                type="text"
                name="city"
                className="input1"
                placeholder="Enter city"
                value={formData.city || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">State</label>
              <input
                type="text"
                name="state"
                className="input1"
                placeholder="Enter state"
                value={formData.state || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">Country</label>
              <input
                type="text"
                name="country"
                className="input1"
                placeholder="Enter country"
                value={formData.country || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">Pincode</label>
              <input
                type="text"
                name="pincode"
                className="input1"
                placeholder="Enter pincode"
                value={formData.pincode || ""}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-8">
              <label className="text-dark mb-1 labelset2 font3">Company/Business Name (Optional)</label>
              <input
                type="text"
                name="business_name"
                className="input1"
                placeholder="Enter company or business name"
                value={formData.business_name || ""}
                onChange={handleChange}
              />
            </div>



<div className="mt-4">
<h2 className="text-dark">Markup Details</h2>
</div>



            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Flight Cashback</label>
              <input
                type="text"
                name="flight_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.flight_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Hotel Cashback</label>
              <input
                type="text"
                name="hotel_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.hotel_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Bus Cashback</label>
              <input
                type="text"
                name="bus_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.bus_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Recharge Cashback</label>
              <input
                type="text"
                name="recharge_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.recharge_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="mt-4">
<h2 className="text-dark">Cost Per Points / Pins</h2>
</div>


<div className="col-md-3">
      <label className="text-dark mb-1 labelset2 font3">Cost Per Pin</label>
      <input
        type="number"
        name="cost_per_pin"
        className="input1"
        placeholder="Enter here"
        value={formData.cost_per_pin || ""}
        onChange={handleChange}
      />
    </div>


          </div>

          <div className="text-end">
            <button type="submit" className="submit-btn mt-3">
              Save Changes
            </button>
          </div>
        </form>
      </div>
               

                
              </div>
            </div>
          </div>
        </div>
      </div>





      
    </>
  );
}

export default EditDistributor;
